import type React from "react";
import { cn } from "@/lib/utils";

export function DescriptionList({ children }: { children: React.ReactNode }) {
    return <dl className="">{children}</dl>;
}

export function DescriptionListItemButton({
    children,
    className,
    width,
    ...props
}: {
    children: React.ReactNode;
    className?: string;
    width?: "full" | "auto";
} & React.ButtonHTMLAttributes<HTMLButtonElement>) {
    return (
        <button
            className={cn(
                "whitespace-nowrap rounded-md transition-all disabled:pointer-events-none disabled:opacity-50 shrink-0 outline-none",
                "hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50",
                "h-8 rounded-md gap-1.5 px-2.5",
                "group/due-date [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-3.5 font-normal! select-none",
                "flex gap-1.5 items-center justify-items-start",
                width === "full" ? "w-full" : "w-auto",
                className
            )}
            {...props}
        >
            {children}
        </button>
    );
}

export function DescriptionListItem({
    label,
    value,
    children,
    icon,
}: {
    label: string;
    value?: string;
    children: React.ReactNode;
    icon?: React.ReactNode;
}) {
    return (
        <div className="py-0 grid grid-cols-[140px_1fr] gap-0 px-0 items-center">
            <dt className=" font-normal text-orsane-primary [&_svg]:size-3.5 flex items-center gap-2">
                {icon}
                {label}
            </dt>
            <dd className=" text-orsane-primary mt-0 min-w-0">
                {value}
                {children}
            </dd>
        </div>
    );
}
